import { useCallback } from 'react';
import { Chip } from './Chip.js';
import styles from './Chip.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'clsx';

/** Presents a set of applied filters which can be removed. */
function ChipTagGroup(props) {
  const {
    size = 'default',
    variant = 'default',
    options,
    onClick,
    onRemove,
    className: callerClassName,
    ...rest
  } = props;
  const handleClick = useCallback(option => () => onClick?.(option), [onClick]);
  const handleRemove = useCallback(option => () => onRemove?.(option), [onRemove]);
  const chipEls = options.map(x => {
    return /*#__PURE__*/jsx(Chip, {
      variant: variant,
      size: size,
      state: "tag",
      onClick: handleClick(x),
      onRemove: handleRemove(x),
      disabled: x.disabled,
      children: x.label
    }, x.value);
  });
  const className = classNames('dsx-component', styles['chip-group'], callerClassName);
  return /*#__PURE__*/jsx("div", {
    ...rest,
    className: className,
    children: chipEls
  });
}
/** Presents a set of applied filters which can be switched between. */
function ChipSelectGroup(props) {
  const {
    size = 'default',
    variant = 'default',
    options,
    onClick,
    selected = [],
    className: callerClassName,
    ...rest
  } = props;
  function handleClick(option) {
    return () => onClick?.(option);
  }
  const selectedValues = selectedAsValueSet(selected);
  const chipEls = options.map(x => {
    const state = selectedValues.has(x.value) ? 'checked' : 'unchecked';
    return /*#__PURE__*/jsx(Chip, {
      variant: variant,
      size: size,
      state: state,
      onClick: handleClick(x),
      disabled: x.disabled,
      children: x.label
    }, x.value);
  });
  const className = classNames('dsx-component', styles['chip-group'], callerClassName);
  return /*#__PURE__*/jsx("div", {
    ...rest,
    className: className,
    children: chipEls
  });
}
function selectedAsValueSet(selected) {
  const asArray = !Array.isArray(selected) ? [selected] : selected;
  const values = asArray.map(x => typeof x === 'string' ? x : x.value);
  return new Set(values);
}

export { ChipSelectGroup, ChipTagGroup };
